import { PrintDomOptions } from './print-dom.model';

export const URL_LONG = /^(((http[s]?)|file):)?(\/\/)+([0-9a-zA-Z-_.=?&].+)$/;
export const URL_SHORT = /^((\.|\.\.)?\/)([0-9a-zA-Z-_.=?&]+\/)*([0-9a-zA-Z-_.=?&]+)$/;
export const DEFAULT_OPTIONS: PrintDomOptions = {
  parent: window.document.body,
  headElements: [],
  bodyElements: [],
};
